import SingleDeliveryTypeTable from './SingleDeliveryTypeTable';
import { OrderDelivery } from '@/store/types';
import { OrderDeliveryInput } from '@/types';

export interface CheckoutDeliveryShipment extends OrderDeliveryInput {
  shipmentId: number;
  selectedAddressId: number | null;
}

interface DeliveriesTableProps {
  deliveries: OrderDelivery[];
}

const DeliveriesTable = (props: DeliveriesTableProps) => {
  const { deliveries } = props;

  return (
    <>
      <p className="text-2-2 md:text-2-0 font-bd mb-1-6">Bestellübersicht</p>
      <div>
        {deliveries?.map(
          (delivery: OrderDelivery) =>
            delivery.items.length > 0 && (
              <SingleDeliveryTypeTable key={delivery.id} delivery={delivery} />
            ),
        )}
      </div>
    </>
  );
};

export default DeliveriesTable;
